import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { MdMenu, MdKeyboardArrowDown } from "react-icons/md";
import logo from "../assets/logo.png";

export default function TopBar(props) {
  const [isScrolled, setIsScrolled] = useState(false);
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
  }

  function handleScroll() {
    if (window.scrollY > 30) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Mfumo wa kubadili lugha ukibonyezwa (Toggles language)
  // const toggleLanguage = () => {
  //   const nextLang = language === "en" ? "sw" : "en";
  //   if (appContext.setLanguage) {
  //       appContext.setLanguage(nextLang);
  //   }
  // };

  return (
    <div className={`TopBar ${isScrolled ? "scrolled" : ""}`}>
      <div className="body">
        <div className="container topbar-flex-container">
          
          {/* LEFT: Branding Area */}
          <div className="topbar-left-brand">
            

            {/* Desktop Logo */}
            <img
              src={logo}
              alt="KUKAJA logo"
              className="align-self-center mDesktopOnly topbar-desktop-logo"
              onClick={() => goTo("home")}
            />

            {/* Mobile Logo */}
            <img
              src={logo}
              alt="KUKAJA logo"
              className="align-self-center mMobileOnly topbar-mobile-logo"
              onClick={() => goTo("home")}
            />
            
            <h1 className="logoName" onClick={() => goTo("home")}>
              MWADEO
            </h1>
          </div>

          {/* CENTER: Dynamic Navigation Menu */}
          <div className="DesktopMenu mDesktopOnly">
            <div
              className="mMenuItem"
              onClick={() => goTo("home")}
              style={{
                borderBottom: appContext.navItem === "home" || !appContext.navItem ? "4px solid var(--secondaryColor)" : "none",
              }}
            >
              HOME
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("about_us")}
              style={{
                borderBottom: appContext.navItem === "about_us" ? "4px solid var(--secondaryColor)" : "none",
              }}
            >
              ABOUT US
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("services")}
              style={{
                borderBottom: appContext.navItem === "services" ? "4px solid var(--secondaryColor)" : "none",
              }}
            >
              SERVICES
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("gallery")}
              style={{
                borderBottom: appContext.navItem === "gallery" ? "4px solid var(--secondaryColor)" : "none",
              }}
            >
              GALLERY
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("membership")}
              style={{
                borderBottom: appContext.navItem === "membership" ? "4px solid var(--secondaryColor)" : "none",
              }}
            >
              MEMBERSHIP
            </div>
          </div>

          {/* RIGHT: Language Selector & Button Actions */}
          <div className="topbar-right-actions ">
          <MdMenu
              className="align-self-center mMobileOnly menu-trigger-icon"
              size={32}
              onClick={appContext.openSideBar}
            />
            {/* <div className="languageSelector" onClick={toggleLanguage}>
              <span>{language.toUpperCase()}</span>
              <MdKeyboardArrowDown size={18} />
            </div> */}

            <button
              className="btn btn-primary font-bold btn-rounded mDesktopOnly topbar-action-btn"
              onClick={() => goTo("contact_us")}
            >
              CONTACT US
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}